import React from "react";
import { useTranslation } from "next-i18next";
import Link from "next/link";
import useHeadsObserver from "./use-heads-observer";

const AboutNavbar = () => {
  const { t } = useTranslation();

  const { activeIds } = useHeadsObserver();
  const [highlightedId, setHighlightedId] = React.useState("");

  const toc = [
    { id: "mission", label: "Mission" },
    { id: "history", label: "History" },
    { id: "vision", label: "Vision" },
    { id: "values", label: "Values" },
    { id: "offices", label: "Offices" },
  ];

  React.useEffect(() => {
    // sort the activeIds by the order of the toc
    const sortedActiveIds = toc
      .map((item) => item.id)
      .filter((id) => activeIds.includes(id));
    if (sortedActiveIds.length === 0) return;
    setHighlightedId(sortedActiveIds[0]);
  }, [activeIds]);

  const scrollIntoViewWithOffset = (selector, offset) => {
    window.scrollTo({
      behavior: "smooth",
      top:
        document.querySelector(selector).getBoundingClientRect().top -
        document.body.getBoundingClientRect().top -
        offset,
    });
  };

  return (
    <div className="fixed top-0 z-50 flex h-28 w-screen flex-row items-center justify-center gap-2 bg-primary-950 p-4 pt-20 font-body text-sm text-white/60 shadow dark-theme:bg-primary high-contrast-theme:font-medium sm:gap-4 sm:text-base">
      {toc.map((item) => (
        <>
          <Link
            key={item.id}
            href={`#${item.id}`}
            className={`transition-all duration-300 hover:text-white/80 ${highlightedId === item.id ? "text-base font-bold text-white sm:text-lg" : ""}`}
            onClick={(e) => {
              e.preventDefault();
              scrollIntoViewWithOffset(`#${item.id}`, 160);
            }}
          >
            {item.label}
          </Link>
          {item.id !== toc[toc.length - 1].id && (
            <div className="h-6 w-px bg-white/60" />
          )}
        </>
      ))}
    </div>
  );
};

export default AboutNavbar;
